import React from 'react';
import HeadBlock from '$/components/global/heading';
import './index.scss';
import { AppState } from '$/store';
import {
  getIsCurrentUserBixbyComplianceAdminState,
  getIsCurrentUserCompanyMNPIInfoAdminState,
  getIsCurrentUserCompanyPublicInfoAdminState,
} from '$/store/profile/selectors';
import { connect } from 'react-redux';
import { Route, Routes } from 'react-router-dom';
import MnpiDataSite from './mnpi';
import NonMnpiDataSite from './non-mnpi';
import HeadingTab from '$/components/global/headingTab';
import { getBixbyComplianceFeatureFlagState } from '$/store/release-feature-flags/selectors';

interface IDataSiteUploadProps {
  isBixbyComplianceAdmin: boolean;
  isCompanyMNPIInfoAdmin: boolean;
  isCompanyPublicInfoAdmin: boolean;
  isBixbyComplianceEnabled: boolean;
}

const ClientDataSite: React.FC<IDataSiteUploadProps> = prop => {
  const { isBixbyComplianceAdmin, isCompanyMNPIInfoAdmin, isCompanyPublicInfoAdmin, isBixbyComplianceEnabled } = prop;
  const baseUrl = `/admin/data-sites`;
  return (
    <React.Fragment>
      <HeadBlock title={'Data Sites'}>
        {(!isBixbyComplianceEnabled || isBixbyComplianceAdmin || isCompanyPublicInfoAdmin) && (
          <HeadingTab title={'Data Sites - Non-MNPI'} link={`${baseUrl}/non-mnpi`} />
        )}
        {isBixbyComplianceEnabled && (isBixbyComplianceAdmin || isCompanyMNPIInfoAdmin) && (
          <HeadingTab title={'Data Sites - MNPI'} link={`${baseUrl}/mnpi`} />
        )}
      </HeadBlock>
      <Routes>
        {(!isBixbyComplianceEnabled || isBixbyComplianceAdmin || isCompanyPublicInfoAdmin) && (
          <Route path={'/non-mnpi'} element={<NonMnpiDataSite />} />
        )}
        {isBixbyComplianceEnabled && (isBixbyComplianceAdmin || isCompanyMNPIInfoAdmin) && (
          <Route path={'/mnpi'} element={<MnpiDataSite />} />
        )}
      </Routes>
    </React.Fragment>
  );
};

const mapStateToProps = (state: AppState) => {
  const { isBixbyComplianceAdmin } = getIsCurrentUserBixbyComplianceAdminState(state);
  const { isCompanyMNPIInfoAdmin } = getIsCurrentUserCompanyMNPIInfoAdminState(state);
  const { isCompanyPublicInfoAdmin } = getIsCurrentUserCompanyPublicInfoAdminState(state);
  const { isBixbyComplianceEnabled } = getBixbyComplianceFeatureFlagState(state);

  return {
    isBixbyComplianceAdmin,
    isCompanyMNPIInfoAdmin,
    isCompanyPublicInfoAdmin,
    isBixbyComplianceEnabled,
  };
};

export default connect(mapStateToProps)(ClientDataSite);
